// extracted by mini-css-extract-plugin
export default {"page":"W0-z","cartModal":"X0-z","checkout":"Y0-z","placeholder":"Z0-z","account":"_0-z"};